import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

/** Tab名称枚举 */
export enum TabName {
  /** 已发现终端 */
  discovered = 'discovered',
  /** 子网发现情况 */
  subnet = 'subnet',
  /** 已忽略终端 */
  ignored = 'ignored'
}

/** 扫描模型枚举 */
export enum ScanModel {
  /** 全部扫描（一键扫描） */
  all = 1,
  /** 批量/单条扫描 */
  batch = 2
}
export enum Discover {
  /** 1-已发现，2-已忽略 */
  discovered = 1,
  ignored = 2
}

/** 扫描子网请求 */
export interface ScanSubnetReq {
  /** 需要扫描的子网id（scan_model=2的时候 ids不能为空） */
  ids?: string[]
  /** 扫描模式 1-全部扫描（一键扫描） 2-批量/单条扫描 */
  scan_model?: ScanModel
}

/** 忽略/取消忽略终端请求 */
export interface IgnoreTerminalReq {
  /** MAC地址列表 */
  macs: string[]
  status: Discover  /** 1-已发现，2-已忽略 */
}
export interface SystemDistribution {
  /** 系统类型：0-全部，1-windows,2-linux，3-windows server，4-mac 5-未知 */
  system_type: number
  /** 该系统类型的终端数量 */
  count: number
  /** 系统名称（前端展示用） */
  system_name: string
}

export interface statisticsResponseData {
  /** 已发现终端总数 */
  discovered_clients?: number
  /** 已忽略终端总数 */
  ignored_clients?: number
  /** 子网地址总数 */
  subnet_count?: number
  /** 已发现终端系统分布 */
  system_distribution?: SystemDistribution[]
  /** 已发现未管控终端数 */
  un_join_count?: number
}
@Injectable()
export class TerminalDiscoveryService {
  constructor (private http: Http) {}

  /** 扫描子网 */
  @InvokeThrottle()
  scanSubnet (data: ScanSubnetReq) {
    return this.http.post<{not_online_device_subnets:string[]}>('/client_find/client_scan', data)
  }

  /** 忽略/取消忽略终端（单个或批量） */
  @InvokeThrottle()
  ignoreTerminal (data: IgnoreTerminalReq) {
    return this.http.post<void>('/client_find/ignore', data)
  }
  getClientFindStatistics () {
    return this.http.post<statisticsResponseData>('/client_find/statistics', {})
  }
}

